export const OrderingGuideSteps = {
  CONTRACT_LIST: 'CONTRACT_LIST',
  CONTRACT_ECS: 'CONTRACT_ECS',
};
